<div class="page-content container">
    <div class="page-header">
      <h1 class="page-title text-primary-d2">
        Caja Mesa
        <small class="page-info text-secondary-d2">
          <i class="fa fa-angle-double-right text-80"></i>
          Roles de partidos
        </small>
      </h1>
    </div>

    <!-- filtro: el oficial de mesa (el administrador elige uno) -->
    <div class="d-flex flex-wrap align-items-end bgc-primary-l4 radius-1 p-2 mb-3">
        <div class="mr-2 mb-1 flex-grow-1" style="min-width: 180px; max-width: 320px;">
            <label class="text-grey-d1 text-90 mb-1">Oficial de mesa</label>
            <select [compareWith]="compararObjectos" class="form-control" required name="usuario" [(ngModel)]="filter.usuario">
                <option [ngValue]="usuario" *ngFor="let usuario of filter.usuarios">{{usuario.nombre_usuario}}</option>
            </select>
        </div>
        <button (click)="getSearch(text_search,null)" class="btn btn-primary mb-1" type="button" name="fullscreen" title="Buscar">
            <i class="fa fa-search mr-1"></i>Buscar
        </button>
        <div class="ml-auto mb-1">
            <app-paginator-header [paginator]="this"></app-paginator-header>
        </div>
    </div>

    <div *ngIf="roles_partidos.length==0" class="text-center text-grey-d1 py-4">No hay roles de partidos para mostrar.</div>

    <!-- una tarjeta por rol; cada fecha asignada abre directo el cierre de ese dia -->
    <div class="row mx-n2">
        <div *ngFor="let rol_partido of roles_partidos" class="col-12 col-sm-6 col-lg-4 px-2 mb-3">
            <div class="card h-100 shadow-sm radius-1 tarjeta-rol" [class.anulado]="!rol_partido.activo">
                <div class="card-body p-2">
                    <div class="d-flex align-items-center">
                        <img class="mr-2 flex-shrink-0" width="52" height="52" style="object-fit: contain;" alt="logo" [src]="rest_server+rol_partido.campeonato.logo" />
                        <div style="min-width: 0;">
                            <div class="font-bolder text-dark-m2 text-105">{{rol_partido.campeonato.nombre}}</div>
                            <div class="text-primary-d1 text-95">{{rol_partido.rol.nombre}}</div>
                            <div class="text-grey text-80">
                                {{rol_partido.codigo}} · actualizado {{rol_partido.updatedAt | date:'dd/MM HH:mm'}}
                                <span *ngIf="!rol_partido.activo" class="badge badge-sm badge-danger ml-1">ANULADO</span>
                            </div>
                        </div>
                    </div>

                    <div *ngIf="rol_partido.activo" class="mt-2">
                        <div *ngIf="rol_partido.fechas_partidos.length==0" class="text-grey text-85">Sin partidos asignados a la mesa.</div>
                        <div class="d-flex flex-wrap">
                            <button *ngFor="let fecha_partido of rol_partido.fechas_partidos" type="button" class="btn-fecha-cierre"
                                (click)="abrirCierreCaja(rol_partido,fecha_partido.fecha)">
                                <i class="fa fa-lock mr-1"></i>
                                <span class="font-bolder">{{fecha_partido.fecha_texto}}</span>
                                <span class="d-block text-80">{{fecha_partido.cantidad_partidos}} partido(s)</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <app-paginator-footer *ngIf="roles_partidos.length>0" class="pagination-detail" [paginator]="this"></app-paginator-footer>
</div>

<ng-template #modal_seleccion_fecha_cierre let-modal>
    <div class="modal-header card-header">
        <div class="col-8">
            <span class="text-blue text-125">Cierre de Caja Mesa</span>
        </div>
        <div class="col-4">
            <button type="button" class="btn btn-primary btn-danger float-right" (click)="modal.dismiss('Cross click')">
                <i class="fa fa-times red2 align-top bigger-125"></i>
            </button>
        </div>
    </div>
    <div class="modal-body card-body">
        <p class="text-dark-m2">
            El oficial de mesa <b>{{filter.usuario.persona.nombre_completo}}</b> tiene partidos asignados en
            <b>{{fechas_cierre.length}}</b> fechas de este rol. Seleccione la fecha del cierre.
        </p>
        <table class="table text-dark-m2 text-95 table-bordered table-hover table-striped">
            <thead class="bgc-white text-grey text-uppercase text-80">
                <tr>
                    <th class="center">Fecha</th>
                    <th class="center">Partidos</th>
                    <th class="center">Estado</th>
                    <th style="text-align: center; width: 80px;" data-field="tools"></th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let fecha_cierre_item of fechas_cierre">
                    <td>{{fecha_cierre_item.fecha_texto}}</td>
                    <td>{{fecha_cierre_item.cantidad_partidos}}</td>
                    <td>
                        <span class="badge badge-sm" [ngClass]="{'badge-warning':fecha_cierre_item.estado=='PENDIENTE','badge-primary':fecha_cierre_item.estado=='GUARDADO','badge-success':fecha_cierre_item.estado=='PROCESADO'}">
                            {{fecha_cierre_item.estado}}
                        </span>
                    </td>
                    <td style="text-align: center;">
                        <div class="action-buttons">
                            <a class="btn radius-1 btn-sm btn-brc-tp btn-outline-default btn-h-outline-danger btn-a-outline-danger btn-text-danger" href="javascript:void(0)" (click)="seleccionarFechaCierre(fecha_cierre_item)">
                                <i class="fa fa-lock text-105"></i>
                            </a>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</ng-template>

<!-- Cierre de caja de la mesa, pensado para pasar la planilla impresa: un partido a la vez, los dos equipos a la vista
     y sus jugadores en el mismo orden de la planilla (codigo, nombre, goles, tarjetas). El marcador sale de los goles. -->
<ng-template #modal_registro_caja_mesa let-modal>
    <div class="modal-header card-header flex-wrap">
        <div class="mb-1">
            <span class="text-blue text-125">Cierre de Caja</span>
            <span class="badge badge-info ml-1">{{fecha_cierre_texto}}</span>
            <span *ngIf="cierre_multiples_fechas" class="badge badge-warning ml-1" title="Cierre registrado antes de la separacion por fecha, agrupa los partidos de varios dias">VARIAS FECHAS</span>
            <span *ngIf="cierre_caja.procesado" class="badge badge-success ml-1">PROCESADO</span>
        </div>
        <div class="ml-auto text-nowrap">
            <button type="button" class="btn btn-sm btn-warning mb-1" (click)="tomarFotoPlanilla()" title="Sacar foto a la planilla y llenar el formulario">
                <i class="fa fa-camera mr-1"></i><span class="d-none d-md-inline">Foto planilla</span>
            </button>
            <button type="button" class="btn btn-sm btn-light-warning mb-1 ml-1" (click)="subirFotoPlanilla()" title="Subir la foto de la planilla desde el dispositivo">
                <i class="fa fa-upload"></i>
            </button>
            <button *ngIf="cierre_caja._id" type="button" class="btn btn-sm btn-success mb-1 ml-1" (click)="generarmensajeWhatsapp()" title="Copiar el resumen para WhatsApp">
                <i class="fab fa-whatsapp"></i>
            </button>
            <button type="button" class="btn btn-sm btn-primary mb-1 ml-1" (click)="guardarRolPartidoCierre()">
                <i class="fa fa-save mr-1"></i>Guardar
            </button>
            <button type="button" class="btn btn-sm btn-danger mb-1 ml-1" (click)="modal.dismiss('Cross click')">
                <i class="fa fa-times"></i>
            </button>
        </div>
    </div>
    <div class="modal-body card-body p-2">
        <!--capture abre directamente la camara del celular, en escritorio el navegador lo ignora y muestra el selector de archivos-->
        <input id="foto-planilla-camara" style="display:none" type="file" accept="image/*" capture="environment" (change)="subirArchivoFotoPlanilla($event)">
        <input id="foto-planilla-archivo" style="display:none" type="file" accept=".png,.jpg,.jpeg" (change)="subirArchivoFotoPlanilla($event)">

        <div *ngIf="cierre_caja.partidos.length==0" class="text-center text-grey-d1 py-4">La mesa no tiene partidos en esta fecha.</div>

        <!-- un boton por partido; la marca verde indica que ya tiene marcador -->
        <div *ngIf="cierre_caja.partidos.length>0" class="d-flex flex-nowrap overflow-auto pb-1 mb-2">
            <button *ngFor="let partido of cierre_caja.partidos; let i=index;" type="button" class="btn btn-sm mr-1 text-nowrap text-left"
                [ngClass]="i==indice_partido?'btn-primary':'btn-outline-primary'" (click)="seleccionarPartido(i)">
                <i class="fas mr-1" [ngClass]="partidoCompleto(partido)?'fa-check-circle text-success-m1':'fa-circle text-grey-l2'"></i>
                <b>{{i+1}}.</b> {{partido.fecha_hora | date:'HH:mm'}}
                <span class="d-none d-md-inline">· {{partido.equipo_1.nombre}} vs {{partido.equipo_2.nombre}}</span>
            </button>
        </div>

        <ng-container *ngIf="cierre_caja.partidos[indice_partido] as partido">
            <!-- los nombres pueden ser largos: van solos en su linea y la disciplina y hora debajo -->
            <div class="mb-2 px-1">
                <div class="text-dark-m2 font-bolder text-105">
                    {{partido.equipo_1.nombre}}
                    <span class="badge badge-primary text-110 mx-1 text-nowrap">{{partido.marcador_equipo_1 ?? '-'}} : {{partido.marcador_equipo_2 ?? '-'}}</span>
                    {{partido.equipo_2.nombre}}
                </div>
                <div class="text-grey text-85">
                    <span *ngIf="partido.disciplina">{{partido.disciplina.nombre}} · </span>
                    <span *ngIf="partido.categoria">{{partido.categoria.nombre}} · </span>
                    {{partido.fecha_hora | date:'HH:mm'}}
                </div>
            </div>
            <div class="row mx-n1">
                <div class="col-12 col-lg-6 px-1 mb-2">
                    <ng-container *ngTemplateOutlet="equipo_caja_mesa; context:{partido:partido,equipo:partido.equipo_1,lado:1}"></ng-container>
                </div>
                <div class="col-12 col-lg-6 px-1 mb-2">
                    <ng-container *ngTemplateOutlet="equipo_caja_mesa; context:{partido:partido,equipo:partido.equipo_2,lado:2}"></ng-container>
                </div>
            </div>
            <div class="text-right mb-2" *ngIf="indice_partido<cierre_caja.partidos.length-1">
                <button type="button" class="btn btn-outline-primary" (click)="siguientePartido()">
                    Siguiente partido<i class="fa fa-arrow-right ml-1"></i>
                </button>
            </div>
        </ng-container>

        <!-- totales de la caja y egresos de la mesa -->
        <div class="radius-1 bgc-grey-l4 border-1 brc-grey-l2 p-2 mt-1">
            <div class="row mx-n1 align-items-end">
                <div class="col-6 col-md-2 px-1 mb-2">
                    <div class="text-grey-d1 text-85">Efectivo</div>
                    <div class="font-bolder text-success-d2 text-110">Bs {{(cierre_caja.total_ingresos_efectivo || 0) | number:'1.2-2'}}</div>
                </div>
                <div class="col-6 col-md-2 px-1 mb-2">
                    <div class="text-grey-d1 text-85">QR</div>
                    <div class="font-bolder text-blue-d2 text-110">Bs {{(cierre_caja.total_ingresos_qr || 0) | number:'1.2-2'}}</div>
                </div>
                <div class="col-4 col-md-2 px-1 mb-2">
                    <label class="text-grey-d1 text-85 mb-0">Pago árbitro</label>
                    <input only-num class="form-control form-control-sm" inputmode="decimal" (focus)="seleccionarTexto($event)" (keyup)="sumarEgresos()" (change)="sumarEgresos()" [(ngModel)]="cierre_caja.pago_arbitro" min="0" type="number" step="0.001">
                </div>
                <div class="col-4 col-md-2 px-1 mb-2">
                    <label class="text-grey-d1 text-85 mb-0">Pago mesa</label>
                    <input only-num class="form-control form-control-sm" inputmode="decimal" (focus)="seleccionarTexto($event)" (keyup)="sumarEgresos()" (change)="sumarEgresos()" [(ngModel)]="cierre_caja.pago_mesa" min="0" type="number" step="0.001">
                </div>
                <div class="col-4 col-md-2 px-1 mb-2">
                    <label class="text-grey-d1 text-85 mb-0">Pago otros</label>
                    <input only-num class="form-control form-control-sm" inputmode="decimal" (focus)="seleccionarTexto($event)" (keyup)="sumarEgresos()" (change)="sumarEgresos()" [(ngModel)]="cierre_caja.pago_otros" min="0" type="number" step="0.001">
                </div>
                <div class="col-6 col-md-1 px-1 mb-2">
                    <label class="text-danger-d1 text-85 mb-0">Faltante</label>
                    <input class="form-control form-control-sm" inputmode="decimal" (focus)="seleccionarTexto($event)" (keyup)="sumarEgresos()" (change)="sumarEgresos()" [(ngModel)]="cierre_caja.saldo_faltante" min="0" type="number" step="0.001">
                </div>
                <div class="col-6 col-md-1 px-1 mb-2">
                    <label class="text-success-d2 text-85 mb-0">Sobrante</label>
                    <input class="form-control form-control-sm" inputmode="decimal" (focus)="seleccionarTexto($event)" (keyup)="sumarIngresos()" (change)="sumarIngresos()" [(ngModel)]="cierre_caja.saldo_sobrante" min="0" type="number" step="0.001">
                </div>
            </div>
            <div class="d-flex justify-content-between align-items-center border-t-1 brc-grey-l2 pt-2">
                <span class="text-grey-d1 text-90">Egresos <b class="text-danger-d1">Bs {{(cierre_caja.total_egresos || 0) | number:'1.2-2'}}</b></span>
                <span class="badge text-white text-125 px-3 py-2" [ngClass]="cierre_caja.saldo_caja>0?'bgc-success':'bgc-danger'">Saldo final Bs {{(cierre_caja.saldo_caja || 0) | number:'1.2-2'}}</span>
            </div>
        </div>
    </div>
</ng-template>

<!-- un equipo del partido, como en la planilla impresa y la app de la tablet: W.O. y marcador, implementos, jugadores con
     goles y tarjetas, y los cobros (los de hoy y las deudas anteriores del club, que se cobran escribiendo el monto) -->
<ng-template #equipo_caja_mesa let-partido="partido" let-equipo="equipo" let-lado="lado">
    <div class="card border-1 brc-primary-l2 radius-1 h-100">
        <div class="card-header bgc-primary-d1 text-white py-1 px-2 d-flex align-items-center">
            <span class="font-bolder flex-grow-1" style="min-width: 0; word-break: break-word;">{{equipo.nombre}}</span>
            <label class="mb-0 mx-2 text-nowrap text-90 px-1 radius-1" [ngClass]="{'bgc-danger':esWO(partido,lado)}" title="El equipo no se presentó">
                <input type="checkbox" class="align-middle mr-1" [ngModel]="esWO(partido,lado)" (ngModelChange)="cambiarWO(partido,lado,$event)">W.O.
            </label>
            <input only-num class="form-control form-control-sm text-center font-bolder text-110" style="width: 56px;" type="number" min="0" step="1" inputmode="numeric"
                title="Marcador (se calcula con los goles de los jugadores)" (focus)="seleccionarTexto($event)"
                [disabled]="partido.w_o_equipo_1.es_wo || partido.w_o_equipo_2.es_wo"
                [ngModel]="obtenerMarcador(partido,lado)" (ngModelChange)="asignarMarcador(partido,lado,$event)"
                [ngClass]="{'brc-danger-m1 border-2':obtenerMarcador(partido,lado)===null || obtenerMarcador(partido,lado)<0}">
        </div>
        <div class="card-body p-0">
            <!-- implementos, como "¿Trajo balón?" de la planilla: NO se cobra -->
            <div class="px-2 pt-2 pb-1">
                <button type="button" class="chip-implemento" (click)="alternarProductoAdicional(partido,equipo,'sin balon')"
                    [ngClass]="implementoCobrado(equipo,'sin balon')?'chip-cobra':'chip-ok'">BALÓN · {{implementoCobrado(equipo,'sin balon')?'NO':'SÍ'}}</button>
                <button *ngIf="partido.disciplina?.nombre!='BALONCESTO' && partido.disciplina?.nombre!='VOLEIBOL'" type="button" class="chip-implemento" (click)="alternarProductoAdicional(partido,equipo,'sin cintillo')"
                    [ngClass]="implementoCobrado(equipo,'sin cintillo')?'chip-cobra':'chip-ok'">CINTILLO · {{implementoCobrado(equipo,'sin cintillo')?'NO':'SÍ'}}</button>
                <button type="button" class="chip-implemento" (click)="alternarProductoAdicional(partido,equipo,'ponchillos')"
                    [ngClass]="implementoCobrado(equipo,'ponchillos')?'chip-cobra':'chip-ok'">PONCHILLOS · {{implementoCobrado(equipo,'ponchillos')?'SÍ':'NO'}}</button>
            </div>

            <!-- jugadores en el orden de la planilla impresa; las tarjetas en sus columnas amarilla y roja -->
            <table class="table table-sm mb-0 text-90 tabla-planilla">
                <thead class="text-80 text-uppercase">
                    <tr>
                        <th class="pl-2 text-grey" style="width: 1%;">Cód</th>
                        <th class="text-grey">Jugador</th>
                        <th class="text-center text-grey" style="width: 1%;">Goles</th>
                        <th class="text-center col-amarilla" style="width: 1%;" title="Tarjeta amarilla">TA</th>
                        <th class="text-center col-roja" style="width: 1%;" title="Tarjeta roja">TR</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let jugador of equipo.jugadores | orderBy:'jugador.persona.nombre_completo'">
                        <td class="pl-2 text-grey text-85 align-middle text-nowrap">{{jugador.jugador.codigo}}</td>
                        <td class="align-middle">
                            {{jugador.jugador.persona.nombre_completo}}
                            <button *ngIf="jugador.jugador.deuda_total>0" type="button" class="btn-debe ml-1" [title]="textoDeudasJugador(jugador.jugador)" (click)="abrirDeudasJugador(equipo,jugador.jugador)">Debe {{jugador.jugador.deuda_total | number:'1.0-2'}}</button>
                        </td>
                        <td class="align-middle py-1">
                            <input type="number" min="0" step="1" inputmode="numeric" class="form-control form-control-sm text-center px-1" style="width: 48px;"
                                (focus)="seleccionarTexto($event)" [ngModel]="jugador.jugador.marcador"
                                (ngModelChange)="cambiarGolesJugador(partido,equipo,lado,jugador.jugador,$event)">
                        </td>
                        <td class="p-0 align-middle col-amarilla">
                            <button type="button" class="celda-tarjeta" title="Tarjeta amarilla" (click)="alternarTarjeta(partido,equipo,jugador.jugador,'AMARILLA')"
                                [class.marcada]="obtenerDetalleTarjeta(equipo,jugador.jugador,'AMARILLA')">{{obtenerDetalleTarjeta(equipo,jugador.jugador,'AMARILLA')?'1':''}}</button>
                        </td>
                        <td class="p-0 align-middle col-roja">
                            <button type="button" class="celda-tarjeta" title="Tarjeta roja" (click)="alternarTarjeta(partido,equipo,jugador.jugador,'ROJA')"
                                [class.marcada]="obtenerDetalleTarjeta(equipo,jugador.jugador,'ROJA')">{{obtenerDetalleTarjeta(equipo,jugador.jugador,'ROJA')?'X':''}}</button>
                        </td>
                    </tr>
                    <tr *ngIf="!equipo.jugadores || equipo.jugadores.length==0">
                        <td colspan="5" class="text-grey text-center">El equipo no tiene jugadores registrados.</td>
                    </tr>
                </tbody>
                <tfoot>
                    <tr>
                        <td colspan="2" class="pl-2">
                            <a href="javascript:void(0)" class="text-blue text-85" (click)="crearNuevoJugador(equipo)"><i class="fas fa-user-plus mr-1"></i>Agregar jugador</a>
                        </td>
                        <td class="text-center font-bolder" title="Suma de goles">{{equipo.total_marcador || 0}}</td>
                        <td colspan="2"></td>
                    </tr>
                </tfoot>
            </table>

            <!-- cobros, pensados para el celular: concepto y total arriba, botones grandes de forma de pago abajo; los montos
                 solo se escriben en un pago parcial o mixto -->
            <div class="border-t-2 brc-grey-l2">
                <div class="text-75 text-uppercase text-grey px-2 pt-1">Cobros</div>
                <div *ngFor="let detalle_pago of obtenerCobrosOrdenados(equipo); trackBy:identificarCobro" class="fila-cobro"
                    [class.pendiente]="detalle_pago.es_pendiente" [class.debe]="obtenerDebeCobro(detalle_pago)>0.001 && (!detalle_pago.es_pendiente || (detalle_pago.importe || 0)+(detalle_pago.qr || 0)>0)">
                    <div class="d-flex justify-content-between align-items-start">
                        <div class="text-90 pr-2" style="min-width: 0;">
                            <span *ngIf="detalle_pago.es_pendiente && !detalle_pago.es_deuda_jugador" class="etiqueta-deuda">DEUDA</span>
                            <span *ngIf="detalle_pago.es_deuda_jugador" class="etiqueta-deuda etiqueta-jugador">JUGADOR</span>
                            <span class="text-dark-m2">{{detalle_pago.producto?.nombre}}</span>
                            <div class="text-grey text-80">{{detalle_pago.fecha}} {{detalle_pago.descripcion}}</div>
                        </div>
                        <div class="text-right text-nowrap">
                            <div class="font-bolder text-105">Bs {{detalle_pago.total | number:'1.2-2'}}</div>
                            <div *ngIf="obtenerFormaPago(detalle_pago)=='MIXTO' && obtenerDebeCobro(detalle_pago)>0.001" class="text-danger-d1 text-80">falta {{obtenerDebeCobro(detalle_pago) | number:'1.2-2'}}</div>
                        </div>
                    </div>
                    <div class="botones-pago">
                        <button type="button" class="btn-pago efectivo" [class.activo]="obtenerFormaPago(detalle_pago)=='EFECTIVO'" (click)="asignarFormaPago(detalle_pago,'EFECTIVO')">
                            <i class="fa fa-money-bill-alt mr-1"></i>Efectivo
                        </button>
                        <button type="button" class="btn-pago qr" [class.activo]="obtenerFormaPago(detalle_pago)=='QR'" (click)="asignarFormaPago(detalle_pago,'QR')">
                            <i class="fa fa-qrcode mr-1"></i>QR
                        </button>
                        <button type="button" class="btn-pago" [ngClass]="detalle_pago.es_pendiente?'no-paga':'fiado'" [class.activo]="obtenerFormaPago(detalle_pago)=='CREDITO'" (click)="asignarFormaPago(detalle_pago,'CREDITO')">
                            {{detalle_pago.es_pendiente?'No paga':'Fiado'}}
                        </button>
                        <button type="button" class="btn-pago parcial" [class.activo]="mostrarMontosCobro(detalle_pago)" (click)="alternarMontosCobro(detalle_pago)">
                            Parcial
                        </button>
                    </div>
                    <div *ngIf="mostrarMontosCobro(detalle_pago)" class="montos-pago">
                        <label class="mb-0">
                            <span class="text-success-d2"><i class="fa fa-money-bill-alt mr-1"></i>Efectivo</span>
                            <input type="number" min="0" step="0.5" inputmode="decimal" class="form-control text-center"
                                (focus)="seleccionarTexto($event)" [(ngModel)]="detalle_pago.importe" (change)="ajustarMontoCobro(detalle_pago,'importe')" (keyup)="sumarIngresos()">
                        </label>
                        <label class="mb-0">
                            <span class="text-blue-d2"><i class="fa fa-qrcode mr-1"></i>QR</span>
                            <input type="number" min="0" step="0.5" inputmode="decimal" class="form-control text-center"
                                (focus)="seleccionarTexto($event)" [(ngModel)]="detalle_pago.qr" (change)="ajustarMontoCobro(detalle_pago,'qr')" (keyup)="sumarIngresos()">
                        </label>
                    </div>
                </div>
                <div class="resumen-cobros px-2 py-1" *ngIf="obtenerResumenCobros(equipo) as resumen">
                    <span>Hoy <b>{{resumen.hoy | number:'1.2-2'}}</b></span>
                    <span *ngIf="resumen.deudas>0">Deudas ant. <b>{{resumen.deudas | number:'1.2-2'}}</b></span>
                    <span class="text-success-d2">Cobrado <b>{{resumen.cobrado | number:'1.2-2'}}</b></span>
                    <span *ngIf="resumen.debe>0" class="text-danger-d1">Fiado hoy <b>{{resumen.debe | number:'1.2-2'}}</b></span>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<!-- deudas de un jugador (de cualquier club o campeonato): se cobran en la mesa como pago del jugador, baja solo su parte -->
<ng-template #modal_deudas_jugador let-modal>
    <div class="modal-header card-header">
        <div class="col-10" style="min-width: 0;">
            <span class="text-blue text-110">{{deuda_jugador_abierta?.jugador.persona.nombre_completo}}</span>
            <div class="text-grey text-85">Debe Bs {{deuda_jugador_abierta?.jugador.deuda_total | number:'1.2-2'}} · juega hoy en {{deuda_jugador_abierta?.equipo.nombre}}</div>
        </div>
        <div class="col-2 text-right">
            <button type="button" class="btn btn-sm btn-danger" (click)="modal.dismiss('Cross click')"><i class="fa fa-times"></i></button>
        </div>
    </div>
    <div class="modal-body card-body p-2" *ngIf="deuda_jugador_abierta">
        <div *ngFor="let deuda of deuda_jugador_abierta.jugador.deudas" class="fila-cobro mb-1" [class.pendiente]="true">
            <div class="d-flex justify-content-between align-items-start">
                <div class="text-90 pr-2" style="min-width: 0;">
                    <div class="text-dark-m2">{{deuda.concepto}}</div>
                    <div class="text-grey text-80">{{deuda.club}} · {{deuda.campeonato}} · {{deuda.fecha | date:'dd/MM/yyyy'}}</div>
                </div>
                <div class="font-bolder text-nowrap">Bs {{deuda.saldo | number:'1.2-2'}}</div>
            </div>
            <ng-container [ngSwitch]="estadoDeudaJugador(deuda)">
                <button *ngSwitchCase="'COBRABLE'" type="button" class="btn-pago efectivo activo w-100 mt-1" (click)="cobrarDeudaJugador(deuda_jugador_abierta.equipo,deuda_jugador_abierta.jugador,deuda)">
                    <i class="fa fa-plus mr-1"></i>Cobrar
                </button>
                <div *ngSwitchCase="'AGREGADO'" class="text-success-d2 text-85 mt-1"><i class="fa fa-check mr-1"></i>Agregada a los cobros: elija ahí efectivo, QR o parcial.</div>
                <div *ngSwitchCase="'EN_EQUIPO'" class="text-orange-d2 text-85 mt-1"><i class="fa fa-info-circle mr-1"></i>Ya está en los cobros del equipo como DEUDA: cóbrela ahí.</div>
                <div *ngSwitchCase="'SIN_DATOS'" class="text-danger-d1 text-85 mt-1"><i class="fa fa-exclamation-triangle mr-1"></i>No se puede cobrar: falta el detalle de la deuda (actualice el servidor y vuelva a abrir la caja).</div>            </ng-container>
        </div>
        <div *ngIf="!deuda_jugador_abierta.jugador.deudas?.length" class="text-grey-d1">No hay detalle de las deudas: vuelva a abrir la caja con internet.</div>
    </div>
</ng-template>

<ng-template #modal_lectura_planilla let-modal>
    <div class="modal-header card-header">
        <div class="col-7">
            <span class="text-blue text-125">Lectura de Planilla</span>
        </div>
        <div class="col-5">
            <button type="button" class="btn btn-primary" (click)="aplicarLecturaPlanilla()" title="Llenar el formulario con estos datos">
                <i class="fa fa-check red2 align-top bigger-125"></i>
            </button>&nbsp;
            <button type="button" class="btn btn-primary btn-danger" (click)="modal.dismiss('Cross click')">
                <i class="fa fa-times red2 align-top bigger-125"></i>
            </button>
        </div>
    </div>
    <div class="modal-body card-body" *ngIf="lectura_planilla">
        <p class="text-dark-m2 text-90 mb-2" *ngIf="lectura_planilla.cabecera">
            <i class="fa fa-file-alt mr-1"></i>{{lectura_planilla.cabecera}}
        </p>
        <div class="alert alert-warning py-1 px-2 mb-2" *ngIf="lectura_planilla.advertencias.length>0">
            <p class="mb-0 text-90" *ngFor="let advertencia of lectura_planilla.advertencias">
                <i class="fa fa-exclamation-triangle mr-1"></i>{{advertencia}}
            </p>
        </div>

        <div class="row mb-2">
            <div class="col-md-8 col-12">
                <label>Partido</label>
                <select [compareWith]="compararObjectos" class="form-control" name="partido_lectura" [(ngModel)]="lectura_planilla.partido" (change)="cambiarPartidoLectura()">
                    <option [ngValue]="partido" *ngFor="let partido of cierre_caja.partidos">{{partido.equipo_1.nombre}} vs {{partido.equipo_2.nombre}}</option>
                </select>
            </div>
            <div class="col-md-4 col-12">
                <label class="d-block">Foto</label>
                <button type="button" class="btn btn-sm btn-light-primary" (click)="lectura_planilla.ver_imagen=!lectura_planilla.ver_imagen">
                    <i class="fa fa-image mr-1"></i>{{lectura_planilla.ver_imagen?'Ocultar':'Ver'}}
                </button>
            </div>
            <div class="col-12 mt-1" *ngIf="lectura_planilla.ver_imagen">
                <img [src]="lectura_planilla.imagen" style="max-width:100%;" alt="planilla" />
            </div>
        </div>

        <div class="card border-0 shadow-sm radius-0 mb-2" *ngFor="let equipo_lectura of lectura_planilla.equipos; let e=index;">
            <div class="card-header bgc-primary-d1">
                <div class="row">
                    <div class="col-md-5 col-12">
                        <label class="text-white mb-0 text-90">Planilla: <b>{{equipo_lectura.planilla.nombre?equipo_lectura.planilla.nombre:'(ilegible)'}}</b></label>
                        <select [compareWith]="compararObjectos" class="form-control" name="equipo_lectura_{{e}}" [(ngModel)]="equipo_lectura.equipo" (change)="cambiarEquipoLectura(equipo_lectura)">
                            <option [ngValue]="lectura_planilla.partido.equipo_1">{{lectura_planilla.partido.equipo_1.nombre}}</option>
                            <option [ngValue]="lectura_planilla.partido.equipo_2">{{lectura_planilla.partido.equipo_2.nombre}}</option>
                        </select>
                    </div>
                    <div class="col-md-3 col-6 input-score">
                        <label class="text-white mb-0 text-90">Marcador</label>
                        <input only-num type="number" min="0" step="1" class="form-control" name="marcador_lectura_{{e}}" [(ngModel)]="equipo_lectura.planilla.marcador_final">
                    </div>
                    <div class="col-md-4 col-6 text-white text-90">
                        <label class="d-block mb-0"><input type="checkbox" name="balon_lectura_{{e}}" [(ngModel)]="equipo_lectura.planilla.cobrar_balon"> Sin balón</label>
                        <label class="d-block mb-0"><input type="checkbox" name="cintillo_lectura_{{e}}" [(ngModel)]="equipo_lectura.planilla.cobrar_cintillo"> Sin cintillo</label>
                        <label class="d-block mb-0"><input type="checkbox" name="ponchillos_lectura_{{e}}" [(ngModel)]="equipo_lectura.planilla.cobrar_ponchillos"> Ponchillos</label>
                    </div>
                </div>
            </div>
            <div class="card-body bgc-transparent p-0 border-1 brc-primary-m3 border-t-0">
                <table class="table table-striped table-hover mb-0 text-95">
                    <thead class="text-dark-l2 text-95">
                        <tr>
                            <th>Planilla</th>
                            <th>Goles</th>
                            <th title="Tarjeta amarilla">🟨</th>
                            <th title="Tarjeta roja">🟥</th>
                            <th>Jugador del sistema</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let jugador_lectura of equipo_lectura.jugadores; let j=index;">
                            <td class="text-dark-m2">
                                {{jugador_lectura.planilla.codigo}} {{jugador_lectura.planilla.nombre}}
                                <span *ngIf="jugador_lectura.planilla.numero" class="badge badge-sm badge-secondary ml-1">N° {{jugador_lectura.planilla.numero}}</span>
                                <span *ngIf="jugador_lectura.planilla.agregado_a_mano" class="badge badge-sm badge-warning ml-1" title="Escrito a mano fuera de la lista impresa">A MANO</span>
                            </td>
                            <td class="input-score">
                                <input only-num style="width: 70px;" type="number" min="0" step="1" class="form-control" name="goles_lectura_{{e}}_{{j}}" [(ngModel)]="jugador_lectura.planilla.goles">
                            </td>
                            <td><input type="checkbox" name="amarilla_lectura_{{e}}_{{j}}" [(ngModel)]="jugador_lectura.planilla.tarjeta_amarilla"></td>
                            <td><input type="checkbox" name="roja_lectura_{{e}}_{{j}}" [(ngModel)]="jugador_lectura.planilla.tarjeta_roja"></td>
                            <td>
                                <select [compareWith]="compararObjectos" class="form-control" name="jugador_lectura_{{e}}_{{j}}" [(ngModel)]="jugador_lectura.jugador_equipo" [ngClass]="{'brc-danger-m1 border-2':!jugador_lectura.jugador_equipo}">
                                    <option [ngValue]="null">- No asignar -</option>
                                    <option [ngValue]="jugador_equipo" *ngFor="let jugador_equipo of equipo_lectura.equipo.jugadores | orderBy:'jugador.persona.nombre_completo'">{{jugador_equipo.jugador.persona.nombre_completo}}</option>
                                </select>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</ng-template>